// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__x3q0f","input":"style_input__1ksFC","btn":"style_btn__1haFQ","update":"style_update__31teR","create":"style_create__2hMF8","link":"style_link__11afD"};